/**
 * The meeting playbook: guidance for the meetings that set the tone in the
 * first hundred days. Words only; nothing is saved here.
 */

import { Disclosure } from '@/components/ds';
import { getAppDefinition } from '../registry';
import { AppShell, ScreenHeading } from '../components/AppShell';
import { AppCard, Eyebrow } from '../components/primitives';
import { MEETING_TEMPLATES } from './framework';

export default function MeetingPlaybookScreen() {
  const app = getAppDefinition('first-100-days')!;
  return (
    <AppShell app={app} backTo="/apps/first-100-days" backLabel="Back to the journey">
      <ScreenHeading title="Meeting playbook" subtitle="The meetings that set the tone, and how to run them." />
      <div className="mt-4 space-y-3">
        {MEETING_TEMPLATES.map((m, index) => (
          <AppCard key={m.id}>
            <Disclosure title={m.title} label={`${m.timing} · ${m.duration}`} defaultOpen={index === 0}>
              <div className="mt-3 space-y-3 font-body text-sm text-[var(--text-sec)]">
                <p>{m.purpose}</p>
                <div>
                  <Eyebrow>Agenda</Eyebrow>
                  <ul className="mt-1 space-y-1">
                    {m.agenda.map((a) => (
                      <li key={`${a.time}-${a.topic}`}>
                        <span className="font-mono text-xs text-[var(--text-ter)]">{a.time}</span> {a.topic}
                        {a.notes ? <span className="block text-xs text-[var(--text-ter)]">{a.notes}</span> : null}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="grid gap-3 sm:grid-cols-2">
                  <div>
                    <Eyebrow>Do</Eyebrow>
                    <ul className="mt-1 list-disc space-y-1 pl-5">
                      {m.doList.map((d) => (
                        <li key={d}>{d}</li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <Eyebrow>Don't</Eyebrow>
                    <ul className="mt-1 list-disc space-y-1 pl-5">
                      {m.dontList.map((d) => (
                        <li key={d}>{d}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div>
                  <Eyebrow>Questions</Eyebrow>
                  <ul className="mt-1 list-disc space-y-1 pl-5">
                    {m.questions.map((q) => (
                      <li key={q}>{q}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </Disclosure>
          </AppCard>
        ))}
      </div>
    </AppShell>
  );
}
